import store from '@/store'
import config from '@/config'
import axios from 'axios'
import url from 'url'
import Query from 'query-string'
import apimodel from '@/model/ApiModel'
import logger from '@/assets/log'
import cookie from "js-cookie"
import i18n from "@/plugins/i18n.js"
const log = logger("api");

let {
    Const
} = apimodel;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const noAlertUrls = [
    "/cmsapi/record/saveRefRecord.action",
    "/cmsapi/extendContent/delete.action",
    "/cmsapi/material/categoryDelete.action",
    "/cmsapi/watermark/delete.action",
    "/cmsapi/extendContent/save.action",
    "/cmsapi/record/startTranscoding.action",
    "/cmsapi/cloudEditor/stopOutputTask.action",
    "/cmsapi/watermark/save.action",
    "/cmsapi/watermark/updateDefault.action",
    "/cmsapi/liveRoomPullForward/save.action",
    "/cmsapi/record/updateRecordOutFlag.action",
    "/cmsapi/record/delete.action",
    "/cmsapi/liveRoom/delete.action",
    "/cmsapi/liveRoom/save.action"
];

// 直接放行接口，不检测 result 字段
const continueUrls = [
    "upload/getUploadServer"
]

export default {
    async call(path, param, query, disableApiError) {

        if(typeof(query) == "boolean"){
            disableApiError = query;
            query = undefined;
        }

        store.commit("api/callResult", {
            code: 0,
            message: "calling"
        });

        let queryStr = Query.stringify(query);
        let action = this.getActionUrl(path);
        let pathStr = action + "?" + queryStr;


        log("call: %s , param: %o", pathStr, param)

        return new Promise(async (resolve, reject) => {
            try {

                let ret = await axios.post(
                    pathStr,
                    param,
                    {
                        headers: {
                            Protocol: location.protocol.replace(':', ''),
                            VgemvCsrfToken: cookie.get("VgemvCsrfToken")
                        }
                    }
                );
    
                log("result: %s , %o", pathStr, ret)
    
                store.commit("api/callResult", {
                    code: 200,
                    message: ""
				});

                if (continueUrls.includes(path)) {
                    resolve(ret.data);
                    return;
                }
				
				if (!ret.data) {
					reject({empty:true});
					return;
				}
    
                if (ret.data.result == Const.Result.Success )
                    resolve(ret.data)
                else if (ret.data.success == true)
                    resolve(ret.data)
                else {
                    // 因为 Const.Result.Offline 在非登录超时也会返回，所以要判断sid
                    if (ret.data.result == Const.Result.Offline && ret.data.sid) {
                        store.commit("api/callResult", {
                            code: 401,
                            message: `${i18n.t('Message.result')}:${ret.data.result}, ${i18n.t('Message.info')}:${ret.data.resultMsg}`,
                            data: ret.data
                        });
                    } else if (!disableApiError && noAlertUrls.indexOf(pathStr) != -1) {
                        store.commit("api/callResult", {
                            code: 500,
                            message: `${i18n.t('Message.result')}:${ret.data.result}, ${i18n.t('Message.info')}:${ret.data.resultMsg}`
                        });
                    }
    
                    reject(ret.data);
    
                }
            } catch(e) {
    
                log.warn("failed: %s , %o", pathStr, e)
    
                if (e.request.status == 404) {
                    store.commit("api/callResult", {
                        code: 404,
                        message: `${i18n.t('Message.callResult.error')}:${e.message}`
                    });
                }  else if (!disableApiError && noAlertUrls.indexOf(pathStr) != -1) {
                    store.commit("api/callResult", {
                        code: 500,
                        message: `${i18n.t('Message.callResult.error')}:${e.message}`
                    });
                }
                reject({
                    code: 500,
                    message: e.message,
                    resultMsg: e.message,
                    data: e
                });
            }
        });
    },
    async callSimple(path, param, query, disableApiError) {

        if(typeof(query) == "boolean"){
            disableApiError = query;
            query = undefined;
        }

        store.commit("api/callResult", {
            code: 0,
            message: "calling"
        });

        let queryStr = Query.stringify(query);
        let pathStr = path + "?" + queryStr;

        log("call: %s , param: %o", pathStr, param);

        try {
            let ret = await axios.post(
                pathStr,
                param,
                {
                    headers: {
                        Protocol: location.protocol.replace(':', ''),
                        VgemvCsrfToken: cookie.get("VgemvCsrfToken")
                    }
                }
            );
            
            log("result: %s , %o", pathStr, ret)

            store.commit("api/callResult", {
                code: 200,
                message: ""
            });
                    
            if (ret.data && ret.data.result == Const.Result.Success )
                return ret.data;
            else if (ret.data.success == true)
                return ret.data;

            throw ret.data;

        } catch (error) {
            if(!disableApiError) {
                store.commit("api/callResult", {
                    code: 500,
                    message: i18n.t('Message.callResult.requestFailed'),
                    data: error
                });
            }
            throw error;
        }
    },
    getActionUrl(path) {
        let server = config.apiServer;

        switch(path) {
            case "realEditor/createRESTask":
            case "api/liveTask/playAddress":
                server = config.cmsServer;
                break;
            case "api/cloudEditor/categories":
            case "api/cloudEditor/topic":
            case "api/cloudEditor/materialList":
                server = config.materialCmsServer;
                break;
            case "upload/getUploadServer":
                server = config.liveCms + "/";
                break;
        }

        return url.resolve(server, path + ".action");
    }
}